import { useMemo } from 'react';
import { isSystemVariable, normalizeVariableLabel, resolveSystemVariable } from "../TemplateVariables.utils";
export function useVariableResolution(detectedVariables, context, templateVariableValues, businessDefaults) {
  return useMemo(() => {
    const resolved = {};
    const defaultsByLabel = new Map(businessDefaults.map(d => [normalizeVariableLabel(d.label), d.defaultValue]));
    for (const label of detectedVariables) {
      const normalizedLabel = normalizeVariableLabel(label);
      if (isSystemVariable(label)) {
        resolved[normalizedLabel] = resolveSystemVariable(label, context);
      } else {
        const proposalValue = templateVariableValues[normalizedLabel];
        if (proposalValue !== undefined && proposalValue !== '') {
          resolved[normalizedLabel] = proposalValue;
        } else {
          const businessDefault = defaultsByLabel.get(normalizedLabel);
          resolved[normalizedLabel] = businessDefault || undefined;
        }
      }
    }
    return resolved;
  }, [detectedVariables, context, templateVariableValues, businessDefaults]);
}